import { PaymentMethod } from "@/services/core-api-adapter";
import { useEffect, useRef } from "react";
import { mapPaymentMethodToPaymentType } from "./mapPaymentMethod";
import { useInsightsAdapter } from "./useInsightsAdapter";
import type { PaymentEventValues } from "./types";

export interface UseTrackPaymentOnSuccessOptions {
  isSuccessState: boolean;
  receipt: { paymentMethod: PaymentMethod; paymentAmount: number } | null;
  chargeCode: string;
  memberId: string;
}

/**
 * Tracks PAYMENT event when payment succeeds. Call once per flow that completes
 * with a payment (Pathology, Vouchering, Intercare consultation).
 */
export function useTrackPaymentOnSuccess({
  isSuccessState,
  receipt,
  chargeCode,
  memberId,
}: UseTrackPaymentOnSuccessOptions) {
  const { trackPayment } = useInsightsAdapter();
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (isSuccessState && receipt && chargeCode && !hasTrackedRef.current) {
      hasTrackedRef.current = true;
      const event: PaymentEventValues = {
        charge_code: chargeCode,
        payment_type: mapPaymentMethodToPaymentType(receipt.paymentMethod),
        payment_amount: Number(receipt.paymentAmount),
        member_id: memberId,
        event_datetime: new Date().toISOString(),
      };
      trackPayment(event);
    }
    if (!isSuccessState) {
      hasTrackedRef.current = false;
    }
  }, [isSuccessState, receipt, chargeCode, memberId, trackPayment]);
}
